import React from 'react';
import {CircularProgress, Stack} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";

// components
import withNavigate from "../../utils/withNavigate";
import retrievePermission from "../../utils/retrievePermission";
import CommonEditModal from "../Common/CommonEditModal";
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import StarIcon from '@mui/icons-material/Star';
import AccountCard from "../Cards/AccountCard";


class OpportunityDetailHeader extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            opportunity: this.props.opportunity,
            permission: 0,
        };
    }

    async componentDidMount(){
        await this.retrievePermission();
    }

    async retrieveOpportunity() {
        this.setState(
            {
                opportunity: null
            }
        );
        const url = `opportunity/${this.props.opportunity.id}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                opportunity: response.data
            }
        );
    }

    async retrievePermission() {
        let p = await retrievePermission(
            'OpportunityViewSet',
            'partial_update',
            this.context.subscriberObject
        )
        this.setState(
            {
                permission: p,
            }
        )
    }

    async feature() {
        const url = `opportunity/${this.props.opportunity.id}/feature/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        if (response.status === 200){
            await this.retrieveOpportunity()
        }
    }

    render() {
        if (!this.state.opportunity) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={1}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="flex-start"
                    alignItems="center"
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                    <CommonCallBackButton
                        flat={true}
                        size={'sm'}
                        variant={this.state.opportunity.featured_by.includes(this.context.subscriberObject.id)?'solid':'soft'}
                        icon={StarIcon}
                        color={this.state.opportunity.featured_by.includes(this.context.subscriberObject.id)?'warning':'neutral'}
                        callBack={this.feature.bind(this)}
                    />
                    <Chip>
                        # {this.state.opportunity.id}
                    </Chip>
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Typography level={'title-md'}>
                            {this.state.opportunity.short_name}
                        </Typography>
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'short_name',
                                ]
                            }
                            baseUrl={'opportunity'}
                            obj={this.state.opportunity}
                            callBack={this.retrieveOpportunity.bind(this)}
                            buttonIconOnly={true}
                        />
                    </Stack>
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Chip
                            color={this.state.opportunity.source?'primary':'danger'}
                            sx={{
                                maxWidth: '150px',
                            }}
                        >
                            {
                                this.state.opportunity.source?
                                    this.state.opportunity.source.title:
                                    'Источник не указан'
                            }
                        </Chip>
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'source',
                                ]
                            }
                            baseUrl={'opportunity'}
                            obj={{
                                id: this.state.opportunity.id,
                                source: this.state.opportunity.source?.id
                            }}
                            callBack={this.retrieveOpportunity.bind(this)}
                            buttonIconOnly={true}
                        />
                    </Stack>
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Chip
                            color={this.state.opportunity.revenue_type?'primary':'danger'}
                            sx={{
                                maxWidth: '150px',
                            }}
                        >
                            {
                                this.state.opportunity.revenue_type?
                                    this.state.opportunity.revenue_type.title:
                                    'Тип выручки не указан'
                            }
                        </Chip>
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'revenue_type',
                                ]
                            }
                            baseUrl={'opportunity'}
                            obj={{
                                id: this.state.opportunity.id,
                                revenue_type: this.state.opportunity.revenue_type?.id
                            }}
                            callBack={this.retrieveOpportunity.bind(this)}
                            buttonIconOnly={true}
                        />
                    </Stack>
                    <Stack
                        direction={'row'}
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <Chip
                            color={this.state.opportunity.lost_reason?'primary':'danger'}
                            sx={{
                                maxWidth: '150px',
                            }}
                        >
                            {
                                this.state.opportunity.lost_reason?
                                    this.state.opportunity.lost_reason.name:
                                    'Причина потери не указана'
                            }
                        </Chip>
                        <CommonEditModal
                            overlay={true}
                            fields={
                                [
                                    'lost_reason',
                                ]
                            }
                            baseUrl={'opportunity'}
                            obj={{
                                id: this.state.opportunity.id,
                                lost_reason: this.state.opportunity.lost_reason?.id
                            }}
                            callBack={this.retrieveOpportunity.bind(this)}
                            buttonIconOnly={true}
                        />
                    </Stack>
                </Stack>
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="flex-start"
                    alignItems="center"
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                        position: 'relative',
                    }}
                >
                    <Typography level={'title-md'}>
                        Полное название: {this.state.opportunity.name}
                    </Typography>
                    <CommonEditModal
                        overlay={true}
                        fields={
                            [
                                'name',
                            ]
                        }
                        baseUrl={'opportunity'}
                        obj={this.state.opportunity}
                        callBack={this.retrieveOpportunity.bind(this)}
                        buttonIconOnly={true}
                    />
                </Stack>
                <Stack
                    direction="row"
                    spacing={2}
                >
                    <AccountCard
                        account={this.state.opportunity.account}
                        mini={true}
                    />
                </Stack>
            </Stack>
        )
    }
}

export default withNavigate(OpportunityDetailHeader);
